import qs from "qs";
import authAxios, { authHeader } from "./data";

const sourceMap: any = {
  1: "Emails",
  2: "Letters",
  3: "Scheduled"
};

const fetchAll = async (request: any) => {
  const response = await authAxios.get(`/api/Mailings/`, {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader()
  });

  return response.data;
};

const fetchCount = async (request: any) => {
  const response = await authAxios.get(`/api/Mailings//Count`, {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader()
  });

  return response.data;
};

const get = async (id: string, type: 1 | 2 | 3) => {
  const result = await authAxios.get(`/api/Mailings/${sourceMap[type]}/${id}`, {
    headers: authHeader()
  });

  return result.data;
};

const createDaily = async (request: any) => {
  const result = await authAxios.post(`/api/Mailings/Emails/createDaily`, request, {
    headers: authHeader()
  });

  return result.data;
};

const sendOne = async (id: string) => {
  const response = await authAxios.put(
    `/api/Mailings/Emails/${id}/Send`,
    {},
    {
      headers: authHeader()
    }
  );

  return response.data;
};

const sendAll = async () => {
  const response = await authAxios.put(
    `/api/Mailings/Emails/sendAll`,
    {},
    {
      headers: authHeader()
    }
  );

  return response.data;
};

const remove = async (id: string, type: 1 | 2 | 3) => {
  const result = await authAxios.delete(`/api/Mailings/${sourceMap[type]}/${id}`, {
    headers: authHeader()
  });

  return result.data;
};

const removeAll = async () => {
  const result = await authAxios.delete(`/api/Mailings/Emails/`, {
    headers: authHeader()
  });

  return result.data;
};

const download = async (id: string) => {
  const response = await authAxios.get(`/api/MailingAttachments/${id}/download`, {
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
    responseType: "blob"
  });

  return response.data;
};

const sendandsend = async (request: any, id: string, type: 1 | 2 | 3) => {
  const response = await authAxios.post(`/api/Mailings/${sourceMap[type]}/${id}/SaveAndSend`, request, {
    headers: authHeader()
  });

  return response.data;
};

const update = async (id: string, request: any) => {
  const response = await authAxios.put(`/api/Mailings/Scheduled/${id}`, request, {
    headers: authHeader()
  });

  return response.data;
};

const cancelEmail = async (id: string) => {
  const response = await authAxios.post(
    `/api/Mailings/scheduled/${id}/cancel`,
    {},
    {
      headers: authHeader()
    }
  );

  return response.data;
};

const schedule = async (request: any) => {
  const response = await authAxios.post("/api/Mailings/scheduled", request, {
    headers: authHeader()
  });

  return response.data;
};

const createLetter = async (request: any) => {
  const response = await authAxios.post("/api/Mailings/Letters", request, {
    headers: authHeader()
  });

  return response.data;
};

const createAndSend = async (request: any) => {
  const response = await authAxios.post("/api/Mailings/Emails/CreateAndSend", request, {
    headers: authHeader()
  });

  return response.data;
};

const resend = async (id: string) => {
  const response = await authAxios.put(`/api/Mailings/Emails/${id}/Resend`, null, {
    headers: authHeader()
  });

  return response.data;
};

const MailingsService = {
  fetchAll,
  fetchCount,
  get,
  sendOne,
  remove,
  removeAll,
  createDaily,
  sendAll,
  download,
  sendandsend,
  cancelEmail,
  update,
  schedule,
  createLetter,
  createAndSend,
  resend
};

export default MailingsService;
